import React from 'react'
import { RichTextSerializer } from '../../../Serializers';
import ArticleV2PaddedSectionWrap from './ArticleV2PaddedSectionWrap';

const ArticleV2Intro = ({data}) => {

    if (!data.introDescription) return null

    return (
        <div className="article-intro">
            <ArticleV2PaddedSectionWrap>
                <RichTextSerializer content={data?.introDescription}/>
            
            </ArticleV2PaddedSectionWrap>

            <style jsx>{`
                .article-intro {
                    padding: 80px 0;
                }

                .article-intro :global(h3) {
                    font-size: 36px;
                    line-height: 1.2;
                    font-weight 400;
                    color: #707070;
                    font-family: 'elizeth';
                    font-style: italic;
                }

                .article-intro :global(h3 *) {
                    font-size: inherit;
                    line-height: inherit;
                    color: inherit;
                    font-family: inherit;
                    font-style: inherit;
                }

                .publish-date {
                    font-size: 22px;
                    font-weight: 300;
                    margin-top: 20px;
                    text-align: center;
                    color: #959595;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .article-intro {
                        padding: 50px 0;
                        // padding-bottom: 0;
                    }
                    .article-intro :global(h3) {
                        font-size: 26px;
                    }
                }


            `}</style>
        </div>


    )
}

export default ArticleV2Intro